import { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

/**
 * Aperçu Code 128 (quiet zone incluse via marges CSS parent).
 */
export default function InternalBarcodePreview({ code, className = '' }) {
  const svgRef = useRef(null);

  useEffect(() => {
    if (!svgRef.current || !code) return;
    try {
      JsBarcode(svgRef.current, code, {
        format: 'CODE128',
        displayValue: false,
        margin: 8,
        width: 2,
        height: 56,
      });
    } catch {
      /* invalid payload — parent should prevent */
    }
  }, [code]);

  if (!code) return null;

  return (
    <div className={className} data-testid="internal-barcode-preview">
      <svg ref={svgRef} role="img" aria-label={`Code-barres ${code}`} />
      <p
        className="text-center font-mono text-sm mt-1 tracking-wide"
        data-testid="produit-internal-barcode-code"
      >
        {code}
      </p>
    </div>
  );
}
